/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */ // props are typed via TS; rule is a false positive
import { MasonryButtonRenderer } from '@leagueplatform/masonry-renderers';

// Overrides the default Masonry button renderer so a trailing-aligned button —
// e.g. the Plan Switcher "View plan" submit — goes full-width on mobile while
// staying right-aligned/hug on wider viewports (per the R1 design). `width` is a
// single server value (no viewport) and the button is a server-driven form-
// submit node, so the responsive width is applied here at the renderer seam
// rather than with brittle CSS targeting the SDK button. Non-trailing buttons
// pass through unchanged. Engine props (incl. `position`) ride along in the
// spread so nothing gets dropped; the incoming `css` merges last.
export const MasonryButtonRendererOverride: typeof MasonryButtonRenderer = ({
  css,
  ...props
}) => (
  <MasonryButtonRenderer
    {...props}
    css={{
      // Full-width on mobile with the label centered (a hug button centers its
      // own label, but a full-width one left-aligns it without this).
      ...(props.position === 'trailing' && {
        '@mobile': { width: '100%', justifyContent: 'center' },
      }),
      ...css,
    }}
  />
);
